'use strict';

/**
 * Modal for printing labels of a collection / set / ...
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 * @author     Stefan Rueschenber <sr@humans.am>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var RestrictionModalView = require('modules/base/views/layout/restriction-labelprint-modal');
var SettingsLabelPrint = require('modules/collection/models/label-print-settings');

var template = require('modules/base/templates/layout/label-print-modal.hbs');

var PrintModalView = ColidoLayoutView.extend({
    template: template,

    /**
     * Holds the currently selected unit
     * @type string (mm | cm | inch)
     */
    selectedUnit: 'mm',

    ui: {
        container: '.advanced-print-modal',
        actionClose: '[data-action="close"]',
        form: 'form',
        title: '[name="title"]',
        formFormat: '[name="format"]',
        pageWidth: '[name="pageWidth"]',
        pageHeight: '[name="pageHeight"]',
        detailFormat: '.custom-detail-format',
        unitsSelects: 'select[name="units"]',
        labelWidth: '[name="labelWidth"]',
        labelHeight: '[name="labelHeight"]',
        labelMarginHorizontal: '[name="labelMarginHorizontal"]',
        labelMarginVertical: '[name="labelMarginVertical"]',
        printLines: '[name="printLines"]',
        isFoldingLabel: '[name="isFoldingLabel"]',
        printPrice: '[name="printPrice"]',
        printLogo: '[name="printLogo"]',
        offsetX: '[name="offsetX"]',
        offsetY: '[name="offsetY"]',
        advancedLabelprint: '.advanced-labelprint',
        convertCurrency: '[name="convertCurrency"]',
        roundCurrency: '[name="roundCurrency"]',
        conversionRounding: '[name="conversionRounding"]',
    },

    events: {
        'click @ui.advancedLabelprint': 'onAdvancedLabelprint',
        'click @ui.actionClose': 'actionClose',
        'submit @ui.form': 'onFormSubmit',
        'keyup input': 'checkInputWithLabel',
        'keyup textarea': 'checkInputWithLabel',
        'keydown input': 'checkInputWithLabel',
        'keydown textarea': 'checkInputWithLabel',
        'change @ui.formFormat': 'onFormFormatChange',
        'change @ui.roundCurrency': 'onRoundCurrencyChange',
        'change @ui.unitsSelects': 'onUnitsSelects',
    },

    itemIds: [],

    initialize: function(options) {
        ColidoLayoutView.prototype.initialize.apply(this, arguments);

        // Load settings model
        this.model = new SettingsLabelPrint();

        this.restricted = !App.user.get('licenseAdvancedLabelPrint');
    },

    onRoundCurrencyChange: function (event) {
        var $curTarget = $(event.currentTarget);
        if ($curTarget.val() === 'none') {
            this.ui.conversionRounding.prop('disabled', true);
        } else {
            this.ui.conversionRounding.prop('disabled', false);
        }
    },

    /**
     * Sets the floating label for input fields
     * @param event
     */
    checkInputWithLabel: function(event) {
        var $curTarget = $(event.currentTarget);
        $curTarget.parents('.input-label-group').toggleClass('has-value', $curTarget.val().length > 0);
    },

    /**
     * Triggered, when a unit is selected
     * @param event
     */
    onUnitsSelects: function(event) {
        var $curTarget = $(event.currentTarget);
        this.setSelectionTo($curTarget.val());
    },

    /**
     * Closes the modal
     * @param {object} event The click
     */
    actionClose: function (event) {
        this.trigger('close:modal');
    },

    /**
     * Sets a new selection based on the selected unit
     * @param {string}   newUnit           The new unit to set
     * @param {boolean} (applyDefSettings) Apply default settings?
     */
    setSelectionTo: function(newUnit, applyDefSettings) {
        this.selectedUnit = newUnit;

        if (_.isUndefined(applyDefSettings)) {
            applyDefSettings = false;
        }

        this.ui.unitsSelects.each(function(i, e) {
            var fromUnit = $(e).val();
            if (fromUnit != newUnit) {
                $(e).val(newUnit);
            }
        });

        if (applyDefSettings) {
            switch(this.ui.formFormat.filter(':checked').val()) {
                case 'a4':
                    this.ui.pageWidth.val(210);
                    this.ui.pageHeight.val(297);

                    this.ui.labelWidth.val(95);
                    this.ui.labelHeight.val(45);
                    this.ui.labelMarginHorizontal.val(1);
                    this.ui.labelMarginVertical.val(1);

                    break;
                case 'letter':
                    this.ui.pageWidth.val(8.5);
                    this.ui.pageHeight.val(11);

                    this.ui.labelWidth.val(4);
                    this.ui.labelHeight.val(1.8);
                    this.ui.labelMarginHorizontal.val(0.04);
                    this.ui.labelMarginVertical.val(0.04);

                    break;
                case 'custom':
                    break;
            }
        }
    },

    /**
     * Is triggered, when the format (paper size) gets changed
     * @param {object} event The change event
     */
    onFormFormatChange: function(event) {
        var isCustom = (event && event.currentTarget) ? $(event.currentTarget).val() : this.model.get('format');

        switch(isCustom) {
            case 'a4':
                this.ui.container.removeClass('is-custom-format');
                this.setSelectionTo('mm', true);
                break;

            case 'letter':
                this.ui.container.removeClass('is-custom-format');
                this.setSelectionTo('inch', true);
                break;

            case 'custom':
                this.ui.container.addClass('is-custom-format');
                break;
        }
    },

    /**
     * Is triggered when the user wants to print the labels
     * @param {object} event The submit event of the form
     */
    onFormSubmit: function(event) {
        event.preventDefault();

        var factor = parseFloat(App.BaseModule.unitsCollection.get(this.selectedUnit).get('factor'));

        this.model.save({
            // Paperformat
            pageWidth: Number(this.ui.pageWidth.val().replace(',', '.')) * factor,
            pageHeight: Number(this.ui.pageHeight.val().replace(',', '.')) * factor,

            // Labelformat
            labelWidth: Number(this.ui.labelWidth.val().replace(',', '.')) * factor,
            labelHeight: Number(this.ui.labelHeight.val().replace(',', '.')) * factor,

            // Layout of one page
            labelMarginHorizontal: Number(this.ui.labelMarginHorizontal.val().replace(',', '.')) * factor,
            labelMarginVertical: Number(this.ui.labelMarginVertical.val().replace(',', '.')) * factor,
            offsetX: Number(this.ui.offsetX.val().replace(',', '.')) * factor,
            offsetY: Number(this.ui.offsetY.val().replace(',', '.')) * factor,

            // Further options
            printLines: this.ui.printLines.filter(':checked').filter(':checked').val() == '1' ? 1 : 0,
            isFoldingLabel: this.ui.isFoldingLabel.filter(':checked').val() == '1' ? 1 : 0,
            printPrice: this.ui.printPrice.filter(':checked').val() == '1' ? 1 : 0,
            printLogo: this.ui.printLogo.filter(':checked').val() == '1' ? 1 : 0,
            format: this.ui.formFormat.filter(':checked').val(),
            units: this.selectedUnit,

            // Currency
            convertCurrency: this.ui.convertCurrency.val() === 'none' ? false : this.ui.convertCurrency.val(),
            roundCurrency:  this.ui.roundCurrency.val() === 'none' ? false : this.ui.roundCurrency.val(),
            roundNCurrency: Number(this.ui.conversionRounding.val()),
        }, {
            success: function() {
                var itemIds = this.getOption('itemIds');
                var setModel = this.getOption('setModel');

                App.radio('collection').execute('print:label', {
                    items: itemIds,
                    set: setModel ? setModel.id : null,
                });
            }.bind(this),
        });

        this.trigger('close:modal');
    },

    onRender: function () {
        var setModel = this.getOption('setModel');

        if (setModel) {
            this.ui.title.val(setModel.get('name'));
        }

        if (this.restricted == true) {
            this.ui.advancedLabelprint.addClass('row-restricted');
        }

        this.ui.roundCurrency.trigger('change');
    },

    onAdvancedLabelprint: function(event) {
        if (this.restricted == true) {
            var restrictionModalView = new RestrictionModalView();
            var options = {
                additionalClassName: 'modal-center modal-restriction',
            };
            App.addModal(restrictionModalView, options);
            event.stopPropagation();
            event.preventDefault();

            return false;
        }
    },

    onShow: function() {
        // Check label groups
        var $element;
        this.$('.input-label-group input, .input-label-group textarea').each(function(idx, element) {
            $element = $(element);
            $element.parents('.input-label-group').toggleClass('has-value', $element.val().length > 0);
        });

        // Render basic size unit
        this.renderSelectOptions(
            this.ui.unitsSelects,
            [
                {
                    key: 'mm',
                    label: App.t('global::units-sizes:mm:short'),
                }, {
                    key: 'cm',
                    label: App.t('global::units-sizes:cm:short'),
                }, {
                    key: 'inch',
                    label: App.t('global::units-sizes:inch:short'),
                },
            ],
            'key',
            'label',
            function (option) {
                return option.value === this.model.get('units');
            }.bind(this)
        );

        if (_.isNull(this.selectedUnit)) {
            this.setSelectionTo('mm', true);
        }
    },
});

module.exports = PrintModalView;